import React, { Component, PropTypes } from 'react';

export default class ProgramCard extends Component {
  constructor(props) {
    super(props);
  }

  createContentMarkup = (content) => {
    return { __html: content };
  };

  render(){
    let htmlBodyCopy;
    let timesList = '';

    htmlBodyCopy = <div dangerouslySetInnerHTML={this.createContentMarkup(this.props.bodyCopy)}></div>;



    if (this.props.isAllDay) {
      timesList = <div className="festivalProgram-allDayWrapper">
        <span className="boldText">Time:</span> All Day!
      </div>
    } else if (this.props.page == 3) {
      timesList = '';
    } else {
      timesList = this.props.times.map((time, idx) => {
        return <li className="festivalProgram-eventTimesListLi" key={`eventTime-${idx}-${time.Begin}`}>
          {time.Begins} - {time.Ends}
        </li>;
      });
    }



    return(
      <div className="festivalProgram-eventCardWrapper">
        <div className="festivalProgram-eventBanner">
          <img className="eventImage" src={this.props.bannerUrl} />
        </div>
        <h2 className="festivalProgram-title">{this.props.title}</h2>

        <div className="festivalProgram-eventLocation">
          <span className="boldText">Location:</span> {this.props.room}
        </div>
        <div className="festivalProgram-eventTimesWrapper">
          <ul className="festivalProgram-eventTimesList">{timesList}</ul>
        </div>
        <div className="festivalProgram-eventCardBody">
          {htmlBodyCopy}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/festival/program/ProgramCard.jsx